export enum WidgetSystemServerSyncState {
    Init = "init",
    InProgress = "in_progress",
    Failed = "failed",
    Success = "success",
}
